<template>
  <el-dialog
    :title="eventTitle + ' - ' + '投稿'"
    :before-close="handleClose"
    :visible.sync="dialog"
    direction="rtl"
    :fullscreen="true"
    :close-on-click-modal="false"
    :lock-scroll="true"
    custom-class="bigFormDialog thesisForm"
  >
    <!--投稿表单内容-->
    <div class="formBox__content">
      <!--投稿表单-->
      <el-form :model="form" ref="form" :rules="rules">
        <!--领域选择器-->

        <el-form-item
          label="选择领域"
          :label-width="formLabelWidth"
          prop="domain_id"
        >
          <el-select
            v-model="form.domain_id"
            placeholder="请选择领域"
            size="small"
          >
            <el-option :value="null" label="请选择"></el-option>
            <el-option
              v-for="item in sortedFields"
              :key="item.domain_id"
              :label="item.name"
              :value="item.domain_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="论文标题(中文):"
          :label-width="formLabelWidth"
          prop="title_zh"
        >
          <el-input v-model="form.title_zh" size="small"></el-input>
        </el-form-item>
        <el-form-item
          label="Thesis Title (en):"
          :label-width="formLabelWidth"
          prop="title_en"
        >
          <el-input v-model="form.title_en" size="small"></el-input>
        </el-form-item>
        <el-form-item
          label="关键词(中文);"
          :label-width="formLabelWidth"
          prop="keywords_zh"
        >
          <TagInput v-model="form.keywords_zh" />
        </el-form-item>
        <el-form-item
          label="Keywords(en):"
          :label-width="formLabelWidth"
          prop="keywords_en"
        >
          <TagInput v-model="form.keywords_en" />
        </el-form-item>
        <el-form-item
          label="作者信息:"
          :label-width="formLabelWidth"
          style="text-align: left"
          required="true"
        >
          <el-button type="primary" plain size="small" @click="openAddMeForm()"
            >+ 我是作者</el-button
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="openAddAuthorForm()"
            >+ 添加作者</el-button
          >
          <el-form-item prop="tableData" style="margin-top: 10px">
            <el-row class="">
              <!--作者表格-->
              <el-table border :data="form.tableData" style="width: 100%">
                <el-table-column
                  :resizable="false"
                  align="center"
                  prop="is_corresponding_author"
                  label="通信作者"
                  width="90"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.is_corresponding_author === true">
                      <i class="el-icon-check"></i>
                    </span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <af-table-column :resizable="false" label="姓名">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.last_name_zh
                      }}<span style="margin-right: 5px" />{{
                        scope.row.first_name_zh
                      }}
                    </div>
                    <div>
                      {{ scope.row.first_name_en
                      }}<span style="margin-right: 5px" />{{
                        scope.row.last_name_en
                      }}
                    </div>
                  </template>
                </af-table-column>
                <af-table-column :resizable="false" label="单位名称">
                  <template slot-scope="scope">
                    <div>{{ scope.row.organization_zh }}</div>
                    <div>{{ scope.row.organization_en }}</div>
                  </template>
                </af-table-column>
                <af-table-column :resizable="false" prop="email" label="邮箱">
                </af-table-column>
                <el-table-column
                  :resizable="false"
                  fixed="right"
                  label="操作"
                  width="150"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="
                        editAuthorRow(scope.$index, scope.row)
                      "
                      type="text"
                      size="small"
                    >
                      编辑
                    </el-button>
                    <el-button
                      v-if="scope.$index === 0"
                      disabled
                      type="text"
                      size="small"
                      >上移</el-button
                    >
                    <el-button
                      v-else
                      type="text"
                      size="small"
                      @click="upLayer(scope.$index, scope.row)"
                      >上移</el-button
                    >
                    <el-button
                      v-if="scope.$index + 1 === form.tableData.length"
                      disabled
                      type="text"
                      size="small"
                      >下移</el-button
                    >
                    <el-button
                      v-else
                      type="text"
                      size="small"
                      @click="downLayer(scope.$index, scope.row)"
                      >下移</el-button
                    >
                    <el-button
                      @click.native.prevent="
                        deleteAuthorRow(scope.$index, form.tableData)
                      "
                      type="text"
                      size="small"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="">
          <div style="text-align: left; line-height: 20px">
            <p><b>投稿须知</b></p>
            <p>
              1.在提交论文时，请在作者一栏中自行调整好写作作者的前后顺序，后期将不接受任何形式的更改，如入选，发布的信息将以报名时您所提交电子稿件中所显示的作者排序为准。
            </p>
            <p>2.提交论文时，请填写论文所有作者的相关信息，并核实准确。</p>
            <p>3.请注意投稿截止日期，超过投稿日期将无法提交；</p>
            <p>
              4.中国经济学年会旨在为中国经济学者提供本领域最新的研究成果及展示的机会，原则上不接受已正式发表的论文。秘书处将组成专家委员会对论文进行匿名评选，并根据评选出来的论文确定会议日程；
            </p>
            <p>
              5.论文入选情况将于“经济金融网”（http://www.efnchina.com/）及中国经济学教育科研网微信公众号（微信号：cenet1998）独家发布。
            </p>
            <p>6.如对论文投稿有疑问，可发邮件咨询，邮箱：cea@pku.edu.cn。</p>
          </div>
        </el-form-item>
        <el-form-item
          label="论文摘要(中文):"
          :label-width="formLabelWidth"
          prop="abstract_zh"
        >
          <el-input
            type="textarea"
            :rows="4"
            v-model="form.abstract_zh"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Thesis abstract (en):"
          :label-width="formLabelWidth"
          prop="abstract_en"
        >
          <el-input
            type="textarea"
            v-model="form.abstract_en"
            :rows="4"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="论文摘要文档:"
          :label-width="formLabelWidth"
          v-if="false"
        >
          <el-upload
            class="upload-box"
            action
            :http-request="uploadFileMethod"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            accept=""
            drag
            :before-upload="beforeUploadDoc"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="form.fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em> <br />只能上传.doc, .docx,
              .pdf文件，且不超过10M
            </div>
          </el-upload>
          <el-row v-if="form.file_url1" class="file_list_style"
            >{{ form.file_name1 }}
            <router-link
              target="_blank"
              :to="'/forum-pub-api/v1/minio/getFile?file_url=' + form.file_url1"
              style="margin-left: 10px"
            >
              <el-button size="small" type="info" plain>下载文件</el-button>
            </router-link>
          </el-row>
        </el-form-item>
        <el-form-item
          label="论文全文文档:"
          :label-width="formLabelWidth"
          prop="file_name2"
        >
          <el-upload
            class="upload-box"
            action
            :http-request="uploadFileMethod2"
            :on-preview="handlePreview2"
            :on-remove="handleRemove2"
            :before-remove="beforeRemove2"
            accept=""
            drag
            :before-upload="beforeUploadDoc2"
            :limit="1"
            :on-exceed="handleExceed2"
            :file-list="form.fileList2"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em> <br />只能上传.doc, .docx,
              .pdf文件，且不超过10M
            </div>
          </el-upload>
          <!-- <el-row v-if="form.file_url2" class="file_list_style"
            >{{ form.file_name2 }}
            <router-link
              target="_blank"
              :to="'/forum-pub-api/v1/minio/getFile?file_url=' + form.file_url2"
              style="margin-left: 10px"
            >
              <el-button size="small" type="info" plain>下载文件</el-button>
            </router-link>
          </el-row> -->
        </el-form-item>

        <el-form-item
          label="入选年会Paper"
          prop="is_working_paper"
          :label-width="formLabelWidth"
        >
          <div style="text-align: left">
            <el-checkbox
              style="text-align: left"
              v-model="form.is_working_paper"
              :rows="4"
              size="small"
            >
              如果中国经济学年会投稿文章入选，同意成为中国经济学年会working
              paper，并在年会网站发布。
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="">
          <div style="text-align: left; line-height: 20px">
            <p><b>投稿声明</b></p>
            <p>
              第一条：必须保证所投稿件为投稿者本人（包括与合作者）独立研究完成之原创性作品，没有侵害他人的知识产权，无任何违法、违纪和违反学术道德的内容。
            </p>
            <p>
              第二条：投稿人能确保所投的年会论文为未曾在任何刊物上发表的研究成果。
            </p>
            <p>第三条：投稿文章版权归作者所有，年会结束后作者可以自主投稿。</p>
            <p>第四条：此声明的修改及更新权均属于中国经济学年会秘书处所有。</p>
          </div>
        </el-form-item>
      </el-form>

      <!-- 添加作者弹窗 -->
      <el-dialog
        title="添加作者"
        :visible.sync="authorDialogVisible"
        :wrapperClosable="false"
        :append-to-body="true"
        :close-on-click-modal="false"
        :lock-scroll="true"
        class="authorInputForm"
        :before-close="handleAuthorDialogClose"
      >
        <el-form
          :model="authorInputForm"
          ref="authorInputForm"
          :rules="authorFormRules"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="中文姓" prop="last_name_zh">
                <el-input
                  size="small"
                  v-model="authorInputForm.last_name_zh"
                  placeholder="输入中文姓"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中文名" prop="first_name_zh">
                <el-input
                  size="small"
                  v-model="authorInputForm.first_name_zh"
                  placeholder="输入中文名"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="中文单位名称" prop="organization_zh">
                <el-input
                  size="small"
                  v-model="authorInputForm.organization_zh"
                  placeholder="输入中文单位名称"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="First Name (en)" prop="first_name_en">
                <el-input
                  size="small"
                  v-model="authorInputForm.first_name_en"
                  placeholder="输入英文名"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Last Name (en)" prop="last_name_en">
                <el-input
                  size="small"
                  v-model="authorInputForm.last_name_en"
                  placeholder="输入英文姓"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Organization (en)" prop="organization_en">
                <el-input
                  size="small"
                  v-model="authorInputForm.organization_en"
                  placeholder="输入英文单位名称"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                label="是否通信作者:"
                prop="is_corresponding_author"
              >
                <el-switch
                  v-model="authorInputForm.is_corresponding_author"
                  active-text="是"
                  inactive-text="否"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="电话(Phone)" prop="phone">
                <el-input
                  size="small"
                  v-model="authorInputForm.phone"
                  placeholder="输入手机或电话"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱(Email)" prop="email">
                <el-input
                  size="small"
                  v-model="authorInputForm.email"
                  placeholder="输入Email"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top: 20px; text-align: center">
          <el-button @click="cancelAuthorForm">取 消</el-button>
          <el-button
            v-if="authorEdit === false"
            type="primary"
            @click="addAuthorRow('authorInputForm')"
            >添加作者</el-button
          >
          <el-button
            v-else
            type="primary"
            @click="saveAuthorRow('authorInputForm')"
            >保存修改</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!--论文投稿底部提交/取消按钮-->
    <div class="formDialog__footer">
      <el-button @click="cancelForm">取 消</el-button>
      <el-button
        v-if="this.manuscriptId === null"
        type="primary"
        @click="handleSubmit('form')"
        :loading="loading"
        >{{ loading ? '提交中 ...' : '提交投稿' }}</el-button
      >
      <el-button
        v-else
        type="primary"
        @click="handleUpdateSubmit('form')"
        :loading="loading"
        >{{ loading ? '提交中 ...' : '更新投稿' }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { postThesis } from '@/apis/thesis.js';
import { postThesisFile } from '@/apis/thesis.js';
import { getMyThesisDetail } from '@/apis/thesis.js';
import { putMyThesisDetail } from '@/apis/thesis.js';
import TagInput from '@/components/TagInput.vue';
// import {getFile} from "@/apis/getFile";

export default {
  name: 'ThesisForm',
  components: {
    TagInput,
  },
  props: {
    fields: Array,
    eventTitle: String,
    eventId: Number,
  },
  data() {
    return {
      dialog: false,
      authorDialogVisible: false,
      manuscriptId: null,
      authorInputForm: {},
      editIndex: null,
      authorEdit: false,
      // 投稿表单数据
      loading: false,
      authorFormRules: {
        // last_name_zh: [
        //     { required: true, message: '请输入中文姓', trigger: 'blur' },
        //     { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        // ],
        // first_name_zh: [
        //     { required: true, message: '请输入中文名', trigger: 'blur' },
        //     { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        // ],
        first_name_zh: [
          { required: true, message: '请输入中文名', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        last_name_zh: [
          { required: true, message: '请输入中文姓', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        phone: [{ validator: this.checkCellPhone, trigger: 'blur' }],
      },
      rules: {
        domain_id: [
          { required: true, message: '请选择领域', trigger: 'change' },
        ],
        title_zh: [
          { required: true, message: '请输入论文中文标题', trigger: 'blur' },
          {
            min: 3,
            max: 255,
            message: '长度在 3 到 255 个字符',
            trigger: 'blur',
          },
        ],
        title_en: [
          { required: true, message: '请输入论文英文标题', trigger: 'blur' },
          {
            min: 3,
            max: 255,
            message: '长度在 3 到 255 个字符',
            trigger: 'blur',
          },
        ],
        tableData: [
          { required: true, message: '至少有一个作者', trigger: 'change' },
        ],
        abstract_zh: [
          {
            required: true,
            message: '请输入论文中文摘要，3000字以内',
            trigger: 'blur',
          },
          { max: 3000, message: '长度在3000个字符以内', trigger: 'blur' },
        ],
        abstract_en: [
          {
            required: true,
            message: '请输入论文英文摘要，4000字符以内',
            trigger: 'blur',
          },
          { max: 4000, message: '长度在4000个字符以内', trigger: 'blur' },
        ],
        keywords_en: [{ required: true, message: '请输入论文英文关键词' }],
        keywords_zh: [{ required: true, message: '请输入论文中文关键词' }],
        file_name2: [
          { required: true, message: '请上传论文全文', trigger: 'change' },
        ],
      },
      form: {
        // 领域选择器数据
        file_url1: '',
        file_url2: '',
        file_name1: '',
        file_name2: '',
        domain_id: null,
        title_zh: '',
        title_en: '',
        keywords_zh: '',
        keywords_en: '',
        tableData: [
          /*
                        {
                            // isFirstAuthor: true,
                            is_corresponding_author: true,
                            first_name_zh: '张',
                            last_name_zh: '某某',
                            first_name_en: 'Moumou',
                            last_name_en: 'Zhang',
                            organization_zh: '中国经济学年会',
                            organization_en: 'Beijing University ',
                            phone: '18899998888',
                            email: 'Zhangxx@email.com',
                        },
                        {
                            // isFirstAuthor: false,
                            is_corresponding_author: false,
                            first_name_zh: '李',
                            last_name_zh: '某某',
                            first_name_en: 'Moumou',
                            last_name_en: 'Lee',
                            organization_zh: '清华大学',
                            organization_en: 'Tsinghua University ',
                            phone: '18899998888',
                            email: 'Leexx@email.com',
                        },*/
        ],
        abstract_zh: '',
        abstract_en: '',
        fileList: [],
        fileList2: [],
        is_working_paper: false,
      },
      ruleForm: {
        fileFormat: '',
      },
      // 表单设定
      formLabelWidth: '140px',
      timer: null,
      fileListShow: false,
    };
  },
  methods: {
    checkCellPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    },
    openForm() {
      this.dialog = true;
      this.getMyThesisFormDetail();
    },
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
      this.form = {
        file_url1: '',
        file_url2: '',
        file_name1: '',
        file_name2: '',
        domain_id: null,
        title_zh: '',
        title_en: '',
        tableData: [],
        abstract_zh: '',
        abstract_en: '',
        fileList: [],
        fileList2: [],
        is_working_paper: false,
      };
    },
    getMyThesisFormDetail() {
      let manuscript_id = this.manuscriptId;
      if (manuscript_id !== null) {
        console.log('投稿弹窗id：', manuscript_id);

        getMyThesisDetail(manuscript_id)
          .then((res) => {
            if (res.status === 200) {
              if (res.data.success === true) {
                console.log(res.data);
                this.form = res.data.data.item;
                this.fileListShow = true;
                this.form.tableData = this.toJson(
                  res.data.data.item.author_info,
                );
                this.form.file_url1 = res.data.data?.item?.abstract_file_path;
                this.form.file_url2 = res.data.data?.item?.manuscript_file_path;
                this.form.file_name1 = res.data.data?.item?.abstract_file_name;
                this.form.file_name2 =
                  res.data.data?.item?.manuscript_file_name;
              } else {
                this.$message.error(res.data.message);
              }
            } else {
              this.$message.error('投稿详情获取失败');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log('新增投稿');
        this.form = {
          file_url1: '',
          file_url2: '',
          file_name1: '',
          file_name2: '',
          domain_id: null,
          title_zh: '',
          title_en: '',
          tableData: [],
          abstract_zh: '',
          abstract_en: '',
          keywords_zh: '',
          keywords_en: '',
          is_working_paper: false,
          //fileList: [],
          //fileList2: [],
        };
        this.fileListShow = false;
      }
    },
    // 打开作者表单对话框
    handleAuthorDialogOpen() {
      this.authorDialogVisible = true;
    },
    // 关闭作者表单对话框
    handleAuthorDialogClose() {
      this.authorDialogVisible = false;
      this.authorInputForm = {};
    },
    // 表格上方 添加作者按钮
    openAddAuthorForm() {
      this.handleAuthorDialogOpen();
      this.authorInputForm = {};
      this.authorEdit = false;
    },
    openAddMeForm() {
      this.handleAuthorDialogOpen();
      this.authorInputForm = {};
      this.$set(
        this.authorInputForm,
        'first_name_zh',
        this.userForm?.first_name_zh,
      );
      this.$set(
        this.authorInputForm,
        'last_name_zh',
        this.userForm?.last_name_zh,
      );
      this.$set(
        this.authorInputForm,
        'first_name_en',
        this.userForm?.first_name_en,
      );
      this.$set(
        this.authorInputForm,
        'last_name_en',
        this.userForm?.last_name_en,
      );
      this.$set(
        this.authorInputForm,
        'organization_zh',
        this.userForm?.institution,
      );
      this.$set(
        this.authorInputForm,
        'organization_en',
        this.userForm?.institution_en,
      );
      this.$set(this.authorInputForm, 'phone', this.userForm?.cellphone);
      this.$set(this.authorInputForm, 'email', this.userForm?.email);
      this.authorEdit = false;
    },
    // 行右侧 编辑文字按钮
    editAuthorRow(index, row) {
      this.handleAuthorDialogOpen();
      this.authorEdit = true;
      this.editIndex = index;
      this.authorInputForm = JSON.parse(JSON.stringify(row));
    },
    // 弹窗底部 （取消-按钮 关闭作者表单对话框）
    cancelAuthorForm() {
      this.handleAuthorDialogClose();
    },
    // 作者弹窗底部（保存修改-按钮）
    saveAuthorRow(authorInputForm) {
      this.$refs[authorInputForm].validate((valid) => {
        if (valid) {
          let j = this.authorInputForm;
          this.$set(this.form.tableData, this.editIndex, j);
          this.handleAuthorDialogClose();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 作者弹窗底部（添加作者-按钮）
    addAuthorRow(authorInputForm) {
      // 将弹窗里的作者数据push到tableData里。
      this.$refs[authorInputForm].validate((valid) => {
        if (valid) {
          let j = this.authorInputForm;
          this.form.tableData.push(j);
          this.handleAuthorDialogClose();
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      this.$refs['form'].validate((valid) => {});
    },

    //上移作者行数据
    upLayer(index) {
      if (index === 0) {
        this.$message({
          message: '处于顶端，不能继续上移',
          type: 'warning',
        });
      } else {
        const that = this;
        const upData = that.form.tableData[index - 1];
        that.form.tableData.splice(index - 1, 1);
        that.form.tableData.splice(index, 0, upData);
      }
    },
    //下移作者行数据
    downLayer(index) {
      const that = this;
      if (index + 1 === that.form.tableData.length) {
        this.$message({
          message: '处于最底端，不能继续下移',
          type: 'warning',
        });
      } else {
        const downData = that.form.tableData[index + 1];
        that.form.tableData.splice(index + 1, 1);
        that.form.tableData.splice(index, 0, downData);
      }
    },
    // 删除作者行
    deleteAuthorRow(index, rows) {
      rows.splice(index, 1);
    },
    // 投稿对话框关闭
    handleClose() {
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },

    // downloadFile1(){
    //     getFile({ file_url : this.form.file_url1 }).then((res) => {
    //         if (res.status === 200) {
    //
    //             // 正常下载保存文件的代码...
    //             const {data} = res
    //             const str = res.headers['content-disposition']
    //             let filename
    //             if (str) {
    //                 filename = str.match(/filename=(\S*?)(;|$)/)[1]
    //             }
    //             filename = filename || '未命名'
    //             if (this.isIE()) {
    //                 window.navigator.msSaveOrOpenBlob(data, filename)
    //             } else {
    //                 const downloadElement = document.createElement('a')
    //                 const href = window.URL.createObjectURL(res.data) // 创建下载的链接
    //                 downloadElement.href = href
    //                 this.form.file_url1 = href;
    //                 downloadElement.download = decodeURI(filename) // 下载后文件名
    //                 document.body.appendChild(downloadElement)
    //                 downloadElement.click() // 点击下载
    //                 document.body.removeChild(downloadElement) // 下载完成移除元素
    //                 window.URL.revokeObjectURL(href) // 释放掉blob对象
    //             }
    //
    //         } else {
    //             this.$message.error('未请求成功');
    //         }
    //     }).catch(error => {
    //         console.log(error);
    //     });
    // },

    // 文件2
    handleRemove2(file2, fileList2) {
      this.form.file_url2 = '';
      this.form.file_name2 = '';
      console.log(file2, fileList2);
    },
    handlePreview2(file2) {
      console.log(file2);
    },
    handleExceed2(files2) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次已选 ${files2.length} 个文件`,
      );
    },
    beforeRemove2(file2) {
      if (
        !(
          file2.name.endsWith('.doc') ||
          file2.name.endsWith('.docx') ||
          file2.name.endsWith('.pdf')
        )
      )
        return true;
      return this.$confirm(`确定移除 ${file2.name}？`);
    },
    beforeUploadDoc2(file2) {
      console.log(file2);
      //上传前回调2
      let fileSize = file2.size / 1024 / 1024 < 10;
      if (
        !(
          file2.name.endsWith('.doc') ||
          file2.name.endsWith('.docx') ||
          file2.name.endsWith('.pdf')
        )
      ) {
        this.$message.error('不支持此文件格式');
        return false;
      } else if (!fileSize) {
        this.$message.error('文件大小不能超过10MB');
        // this.form.fileList2 = [];
        return false;
      } else {
        this.ruleForm.fileFormat = file2;
      }
    },
    // 上传正文文件部分
    uploadFileMethod2(fileList2) {
      let fileObject = fileList2.file;
      let formData = new FormData();
      formData.append('file_name', fileObject);
      postThesisFile(formData, { forum_id: this.eventId })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.$message.success('论文上传成功，请点击提交完成投稿。');
              this.form.file_url2 = res.data.data.file_url;
              this.form.file_name2 = fileObject.name;
              this.$refs['form'].validate((valid) => {});
              console.log(fileObject);
            } else {
              this.$message.error(res.data.message);
            }
          } else {
            this.$message.error('未上传成功');
            console.log('错误');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 文件1
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次已选 ${files.length} 个文件`,
      );
    },
    beforeRemove(file) {
      if (
        !(
          file.name.endsWith('.doc') ||
          file.name.endsWith('.docx') ||
          file.name.endsWith('.pdf')
        )
      )
        return true;
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeUploadDoc(file) {
      //上传前回调
      let fileSize = file.size / 1024 / 1024 < 10;
      if (
        !(
          file.name.endsWith('.doc') ||
          file.name.endsWith('.docx') ||
          file.name.endsWith('.pdf')
        )
      ) {
        this.$message.error('不支持此文件格式');
        return false;
      } else if (!fileSize) {
        this.$message.error('大小不能超过10MB');
        return false;
        // this.form.fileList = [];
      } else {
        this.ruleForm.fileFormat = file;
      }
    },
    // 上传摘要文件部分
    uploadFileMethod(fileList) {
      let fileObject = fileList.file;
      let formData = new FormData();
      formData.append('file_name', fileObject);
      postThesisFile(formData, { forum_id: this.eventId })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              console.log(res.data, fileObject);
              this.form.file_url1 = res.data.data.file_url;
              this.form.file_name1 = fileObject.name;
            } else {
              this.$message.error(res.data.message);
            }
          } else {
            this.$message.error('未上传成功');
            console.log('错误');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 提交投稿表单
    handleSubmit(form) {
      if (this.loading) {
        return;
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$confirm('确定要提交投稿表单吗？')
            .then(() => {
              postThesis({
                forum_id: this.eventId,
                domain_id: this.form.domain_id,
                title_zh: this.form.title_zh,
                title_en: this.form.title_en,
                abstract_zh: this.form.abstract_zh,
                abstract_en: this.form.abstract_en,
                manuscript_file: '删除此请求字段',
                abstract_file_path: this.form.file_url1,
                abstract_file_name: this.form.file_name1,
                manuscript_file_path: this.form.file_url2,
                manuscript_file_name: this.form.file_name2,
                author_info: JSON.stringify(this.form.tableData),
                keywords_en: this.form.keywords_en,
                keywords_zh: this.form.keywords_zh,
                is_working_paper: this.form.is_working_paper,
              })
                .then((res) => {
                  this.loading = true;
                  this.timer = setTimeout(() => {
                    // 动画关闭需要一定的时间
                    if (res.status === 200) {
                      setTimeout(() => {
                        this.loading = false;
                        this.$alert('论文提交成功！' + res.data.message, {
                          confirmButtonText: '确定',
                        });
                        console.log(res.data);
                        this.cancelForm();
                        this.$router.push({
                          path: '/myThesisList',
                          query: { eventId: this.eventId },
                        });
                      }, 800);
                    } else {
                      this.$message.error('提交失败！');
                      this.loading = false;
                      console.log('错误');
                    }
                  }, 500);
                })
                .catch(() => {
                  this.$message.error('提交失败！');
                });
            })
            .catch(() => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleUpdateSubmit(form) {
      if (this.loading) {
        return;
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$confirm('确定要提交投稿表单吗？')
            .then(() => {
              let manuscript_id = this.manuscriptId;
              putMyThesisDetail(manuscript_id, {
                forum_id: this.eventId,
                domain_id: this.form.domain_id,
                title_zh: this.form.title_zh,
                title_en: this.form.title_en,
                abstract_zh: this.form.abstract_zh,
                abstract_en: this.form.abstract_en,
                abstract_file_path: this.form.file_url1,
                abstract_file_name: this.form.file_name1,
                manuscript_file_path: this.form.file_url2,
                manuscript_file_name: this.form.file_name2,
                author_info: JSON.stringify(this.form.tableData),
                keywords_en: this.form.keywords_en,
                keywords_zh: this.form.keywords_zh,
                is_working_paper: this.form.is_working_paper,
              })
                .then((res) => {
                  this.loading = true;
                  this.timer = setTimeout(() => {
                    // 动画关闭需要一定的时间
                    if (res.status === 200) {
                      setTimeout(() => {
                        this.loading = false;
                        this.$alert('论文提交成功！' + res.data.message, {
                          confirmButtonText: '确定',
                        }).then(() => {
                          this.$router.push({
                            path: '/myThesisList',
                            query: { eventId: this.eventId },
                          });
                        });
                        console.log(res.data);
                        this.dialog = false;
                      }, 500);
                    } else {
                      this.$message.error('未请求成功');
                      this.loading = false;
                      console.log('错误');
                    }
                  }, 500);
                })
                .catch(() => {
                  this.$message.error('未请求成功');
                });
            })
            .catch(() => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    toJson(str) {
      let jsonToObj = JSON.parse(str);
      // console.log(jsonToObj);
      return jsonToObj;
    },
  },
  computed: {
    userForm: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUserInfo;
      },
    },
    sortedFields() {
      return this.fields.slice().sort((a, b) => a.sort_order - b.sort_order);
    },
  },
};
</script>

<style scoped></style>
